
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const Hero = () => {
  const { t } = useTranslation('common');

  return (
    <section className="relative min-h-screen flex items-center">
      {/* Background Image - Personal Photo */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: 'url(https://static.readdy.ai/image/42d13efc32449c379a28fcec32248951/234831dbc6f73b4ffd44e624f0eeab63.jpeg)'
        }}
      />
      <div className="absolute inset-0 bg-black/50" />
      
      {/* Content */}
      <div className="relative w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl">
          {/* Company Logo and Name */}
          <div className="flex items-center space-x-4 mb-8">
            <img 
              src="https://static.readdy.ai/image/42d13efc32449c379a28fcec32248951/43e47bc0135f16267a464c8a3f4fef40.jpeg" 
              alt="Alpbuild.ch Logo" 
              className="h-16 w-auto drop-shadow-lg"
            />
            <div className="flex flex-col">
              <div className="text-4xl md:text-5xl font-bold bg-gradient-to-br from-amber-700 via-green-600 to-yellow-600 bg-clip-text text-transparent drop-shadow-2xl" 
                   style={{ 
                     fontFamily: '"Inter", "Helvetica Neue", sans-serif',
                     letterSpacing: '0.15em',
                     textShadow: '3px 3px 6px rgba(0,0,0,0.25), 2px 2px 4px rgba(139,69,19,0.4)',
                     filter: 'drop-shadow(2px 2px 4px rgba(0,0,0,0.2))'
                   }}>
                Alpbuild.ch
              </div>
              <div className="text-lg md:text-xl text-green-300 font-medium mt-2" 
                   style={{ fontFamily: '"Inter", "Helvetica Neue", sans-serif' }}>
                Qualité. Fiabilité. Précision suisse.
              </div>
            </div>
          </div>
          <h1 className="text-4xl md:text-6xl font-bold text-white mb-6 leading-tight">
            Qualité. Fiabilité. Précision suisse.
          </h1>

          <p className="text-xl md:text-2xl text-white/90 mb-8 leading-relaxed">
            Services de construction professionnels dans les cantons de Vaud et Genève. Des rénovations complètes aux travaux de finition spécialisés, nous livrons des résultats exceptionnels avec la précision suisse.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 mb-12">
            <Link
              to="/contact"
              className="bg-blue-600 text-white px-8 py-4 rounded-lg text-lg font-medium hover-bg-blue-700 transition-colors text-center whitespace-nowrap"
            >
              <i className="ri-message-3-line mr-2"></i>
              Get Free Quote
            </Link>
            <a
              href="tel:+41772184502"
              className="bg-white/10 backdrop-blur-sm text-white border-2 border-white/30 px-8 py-4 rounded-lg text-lg font-medium hover:bg-white/20 transition-colors text-center whitespace-nowrap"
            >
              <i className="ri-phone-line mr-2"></i>
              Call Now
            </a>
          </div>

          {/* Quick Stats */}
          <div className="grid grid-cols-3 gap-6 max-w-lg">
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-bold text-white mb-1">80+</div>
              <div className="text-white/80 text-sm">Projects</div>
            </div>
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-bold text-white mb-1">21+</div>
              <div className="text-white/80 text-sm">Years</div>
            </div>
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-bold text-white mb-1">100%</div>
              <div className="text-white/80 text-sm">Quality</div>
            </div>
          </div>

        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2">
        <div className="w-6 h-10 border-2 border-white/50 rounded-full flex justify-center">
          <div className="w-1 h-3 bg-white/50 rounded-full mt-2 animate-bounce"></div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
